// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"94010fe5","990":"f18c55fb"}[chunkId] + ".chunk.js";
};